export default __webpack_public_path__ + "static/media/gallery.4e03634b.svg";